export default "__VITE_ASSET__DNk0aaWA__"